import { Tabs } from '../components/Tabs/Tabs'
import { Item } from '@react-stately/collections'
import { BarChart, UserProfile1 } from 'blaze-ui/icons'
import Styles from '../Analytics.module.scss'
import { Overview } from './Overview'
import { useAnalyticsTabs } from '../hooks/useAnalyticsTabs'
import { Audience } from './Audience'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

const InstagramAnalytics = () => {
  const { tab, handleTabChange } = useAnalyticsTabs()
  const audienceAnalyticsEnabled = useFlipperFlag('audience_metrics')

  return (
    <div className={Styles.content}>
      <Tabs aria-label="Instagram Analytics Tabs" selectedKey={tab} onSelectionChange={handleTabChange}>
        <Item
          key="overview"
          title={
            <div className={Styles.tabTitle}>
              <BarChart />
              Overview
            </div>
          }
        >
          <Overview />
        </Item>
        {audienceAnalyticsEnabled && (
          <Item
            key="audience"
            title={
              <div className={Styles.tabTitle}>
                <UserProfile1 />
                Audience
              </div>
            }
          >
            <Audience />
          </Item>
        )}
      </Tabs>
    </div>
  )
}

export default InstagramAnalytics
